export const HEADING_FONTS = [
  "Playfair Display", "Lora", "Cormorant Garamond", "Merriweather",
  "Montserrat", "Poppins", "Raleway", "Josefin Sans",
  "Oswald", "Bebas Neue", "Pacifico", "Dancing Script",
];

const loaded = new Set();

export const loadGoogleFont = (family) => {
  if (!family || loaded.has(family)) return;
  loaded.add(family);
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(family).replace(/%20/g, "+")}:wght@400;600;700&display=swap`;
  document.head.appendChild(link);
};
